import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { FontScheme } from './font-scheme';
/**
 * @private
 */
export class Themes {
    get fontScheme() {
        return this.fntScheme;
    }
    set fontScheme(value) {
        this.fntScheme = value;
    }
    constructor(node) {
        this.fntScheme = new FontScheme();
    }
    copyFormat(themes) {
        if (!isNullOrUndefined(themes)) {
            this.fntScheme.copyFormat(themes.fntScheme);
        }
    }
    destroy() {
        this.fntScheme = undefined;
    }
}
